module.exports = __webpack_public_path__ + "static/hero1-02a1fa01f3e56afc4a4fa8e111ff81b9.jpeg";